import { ShowError, ShowSuccess } from "../../helper/Alert";

import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { fetchPwaUserConfigSuccess, setUserConfigSuccess } from "../actions";
import { ActionTypes } from "../../constants/ActionTypes";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// function* fetchPWAUserConfigRequest() {
//     try {
//         const fetchedUserConfig = yield call(getPwaNeededUserConfig);

//         yield put(fetchPwaUserConfigSuccess(fetchedUserConfig.data));
//     } catch (error) {
//         return ShowError("", error);
//     }
// }

// export function* getPWAUserConfig() {
//     yield takeEvery(ActionTypes.GET_PWA_USER_CONFIG, fetchPWAUserConfigRequest);
// }

const getPwaNeededUserConfig = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get("userConfig/GetUserConfig");
}
const setPwaThemeUserConfig = async (param: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post(`userConfig/SetTheme`, param);
}

function* fetchPwaUserConfigRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedNews = yield call(getPwaNeededUserConfig);
        yield put(fetchPwaUserConfigSuccess(fetchedNews.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchPwaUserConfig() {
    yield takeEvery(ActionTypes.GET_PWA_USER_CONFIG, fetchPwaUserConfigRequest);
}

function* fetchSetUserConfig(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);

    try {
        const fetchedsetPwaTheme = yield call(setPwaThemeUserConfig, action.payload);
        yield put(setUserConfigSuccess(fetchedsetPwaTheme.data));
        // yield call(setPwaThemeUserConfig, action.payload);
        // yield put(setUserConfigSuccess());

        ShowSuccess(messages["messages.operationWasSuccessful"], "");

    } catch (error) {
        return ShowError("", error);
    }
}

export function* setUserConfig() {
    yield takeEvery(ActionTypes.SET_USER_CONFIG, fetchSetUserConfig);
}

export default function* rootSaga() {
    yield all([fork(fetchPwaUserConfig), fork(setUserConfig)]);
}
